import defautImage from "./../../../assests/defaultImage.png"
import { useEffect, useState } from "react";
import { deleteNarray8Comment, toggleLikeNarray8Comment } from "../../../redux/naray8/naray8Action";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { formatNumber, formatTime } from "../../../helper";

const Naray8CommentItem = ({ comment, authorId, onReply, isReply }) => {
    const queryClient = useQueryClient()
    const authUserId = useSelector((state) => state.user?.userData?.userId);
    const { user, commentId, createdAt, likeCount, isLiked: liked, narrateId, chapterId, replies, body } = comment ?? {};
    const { firstName, lastName, profilePhoto, userId } = user ?? {}
    const isAuthor = userId === authorId
    const isMyComment = userId === authUserId
    const profileImage = profilePhoto && profilePhoto.length > 0 ? profilePhoto[0].photoPublicUrl : defautImage
    const [isLiked, setIsLiked] = useState(liked || false)
    const [likeCounter, setLikeCounter] = useState(likeCount || 0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (liked !== isLiked) {
            setIsLiked(liked)
        }

        if (likeCount !== likeCounter) {
            setLikeCounter(likeCount)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [liked, likeCount])

    const toggleLike = async () => {
        try {
            setLikeCounter(prev => isLiked ? prev - 1 : prev + 1)
            setIsLiked(prev => !prev)
            await toggleLikeNarray8Comment(commentId);
        }
        catch (error) {
            setLikeCounter(prev => isLiked ? prev + 1 : prev - 1)
            setIsLiked(prev => !prev)
        }
    }

    const handleDeleteComment = async () => {
        try {
            setLoading(true)
            await deleteNarray8Comment(commentId)
            toast.success("Comment deleted successfully")
            if (chapterId) {
                queryClient.invalidateQueries({ queryKey: ["naray8", "chapter", chapterId, "comments"] })
            } else {
                queryClient.invalidateQueries({ queryKey: ["naray8", narrateId, "comments"] })
            }
        } catch (error) {
            toast.error("Failed to delete comment. Please try again.")
        } finally {
            setLoading(false)
        }
    }



    return (
        <div className="flex gap-1.5">
            <div>
                <img
                    src={profileImage}
                    alt="Reader avatar"
                    className="rounded-full w-10 aspect-square "
                />
            </div>
            <div className="flex-1">
                <div className="flex items-center gap-2 font-sora">
                    <p className="font-semibold text-[15px] text-[#E0DDFA] leading-6">{firstName} {lastName}</p>
                    {isAuthor && <span className="text-[9px] font-[Abel]">Author</span>}
                </div>
                <p className="text-sm font-sora tracking-[1.4px]">{body}</p>
                <div className={`${loading ? "pointer-events-none opacity-75 cursor-not-allowed" : ""} flex items-center gap-2 text-xs text-white font-outfit font-semibold`}>
                    <span>{formatTime(createdAt)}</span>
                    {!isReply && <button onClick={() => onReply(comment)}>Reply {replies?.length}</button>}
                    {/* {replies?.length > 0 && <button>View replies {replies?.length}</button>} */}
                    <button className={`${isLiked ? "text-customGold" : "text-white"}`} onClick={toggleLike} >{isLiked ? "Liked" : "Like"} ({formatNumber(likeCounter)})</button>
                    {isMyComment && <button disabled={loading} className="text-red-400" onClick={handleDeleteComment}>Delete</button>}
                </div>

                {replies?.length > 0 && (
                    <div className="mt-2 space-y-4 border-l-2 border-[#9B9B9B] pl-2">
                        {replies.map((reply) => (
                            <Naray8CommentItem key={reply.commentId} comment={reply} authorId={authorId} onReply={onReply} isReply />
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Naray8CommentItem;